<template>
  <div class="mui-numbox" ref="root">
    <button class="mui-btn mui-btn-numbox-minus" type="button" @click="add(-1)">-</button>
    <input class="mui-input-numbox" type="number" v-model.number="model" @input="change" :min="min" :max="max" />
    <button class="mui-btn mui-btn-numbox-plus" type="button" @click="add(1)">+</button>
  </div>
</template>

<script>
  // import FastClick from 'fastclick'

  export default {
    name: 'MuiNumbox',
    data() {
      return {
        model: 0
      }
    },
    props: {
      value: Number,
      max: Number,
      min: Number,
    },
    created() {
      this.model = this.value
    },
    mounted() {
      // this.$nextTick(() => {
      //   FastClick.attach(this.$el)
      // })
    },
    methods: {
      add(i) {
        this.set(this.value + i)
      },
      set(val) {
        val = Math.max(val, this.min)
        val = Math.min(val, this.max)
        this.model = val
        this.$emit('input', val)
      },
      change() {
        this.$nextTick(() => {
          this.set(this.model)
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Mui/Numbox.vue